<template>
  <div>
    <div class="flex-def flex-cCenter flex-zBetween" style="margin-bottom: 1rem">
      <div class="y-desc" style="font-size: 1rem">公告编辑</div>
      <el-button @click="$router.back()" type="text" size="mini">返回列表</el-button>
    </div>
    <el-card style="min-height: 45rem">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form>
            <el-form-item>
              <y_editor v-model="form.detail"></y_editor>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form label-width="4rem">
            <el-form-item label="排序">
              <el-input-number v-model="form.sort"></el-input-number>
            </el-form-item>
            <el-form-item label="标题">
              <el-input v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="描述">
              <el-input v-model="form.desc"></el-input>
            </el-form-item>
            <el-form-item label="缩略图">
              <y_upload_img v-model="form.pic"></y_upload_img>
            </el-form-item>
            <el-form-item>
              <el-button @click="edit" type="primary">保存</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import y_upload_img from "@/components/y-form/y-upload/y_upload_img";
import y_editor from "@/components/y-form/y-editor/y_editor";
export default {
  name: "edit",
  components:{
    y_upload_img,
    y_editor,
  },
  data() {
    return {
      edit_id:0,
      form:{
        sort:0,
        title:"",
        desc:"",
        pic:"",
        detail:""
      },
    }
  },
  mounted() {
    if (this.$route.query.id){
      this.edit_id = parseInt(this.$route.query.id);
      this.load();
    }
  },
  methods: {
    load() {
      this.$u.api.shop.plugin.privilegeCard.confNoticeOne({id:this.edit_id}).then(res=>{
        this.form = res;
      })
    },
    edit(){
      this.$u.api.shop.plugin.privilegeCard.confNoticeEdit(this.form).then(()=>{
        this.$message.success("操作成功");
        this.$router.back();
      })
    },
  }
}
</script>

<style scoped>

</style>